export const isNumber = (x: any): x is number => typeof x === 'number';

export const sum = (total: number, price = 0): number => total + price;
